var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 49,
    viewBox: "0 0 4 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(7221.868 -7883.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7883.867)",
    fill: "#2197ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7892.867)",
    fill: "#2197ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7901.867)",
    fill: "#2197ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7910.867)",
    fill: "#2197ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7919.867)",
    fill: "#2197ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7221.868 7928.867)",
    fill: "#2197ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailDots);
export default __webpack_public_path__ + "static/media/trailDots.40557bdeb2c6e22a12404344489819b0.svg";
export { ForwardRef as ReactComponent };